export function findActionRoot(object) {
  for (let current = object; current; current = current.parent) {
    if (current.userData?.action) return current;
  }
  return null;
}

export function isWorldVisible(object) {
  if (!object) return false;
  for (let current = object; current; current = current.parent) {
    if (current.visible === false) return false;
  }
  return true;
}

function isHitMaterialVisible(hit) {
  const materials = hit.object.material;
  const material = Array.isArray(materials)
    ? materials[hit.face?.materialIndex ?? 0] : materials;
  // Invisible materials cannot render, but opacity-zero meshes are intentional
  // hit proxies for small resources, fish and interaction stations.
  return material?.visible !== false;
}

export function pickWorldAction(raycaster, roots, isEnabled = () => true, isHitVisible = () => true) {
  const hits = raycaster.intersectObjects(roots.filter(isWorldVisible), true);
  // Three.js raycasting includes hidden descendants. Continue past those hits
  // and disabled actions so they cannot cover a valid target farther back.
  for (const hit of hits) {
    if (!isWorldVisible(hit.object) || !isHitMaterialVisible(hit) || !isHitVisible(hit)) continue;
    const root = findActionRoot(hit.object);
    if (root && isEnabled(root)) return { hit, root };
  }
  return null;
}
